import React from "react";
import { ReactComponent as FooterLogo } from "@/assets/images/yellow_logo.svg";
import { useTransactionData } from "@/context/transactionContext";

function Footer1xbet() {
  const { transactionData } = useTransactionData();
  const shouldRenderLogo = !transactionData?.merchant?.checkout_hide_brand;

  return (
    <div className="flex items-center justify-center h-[50px] bg-cripten-dark w-full">
      {shouldRenderLogo && <FooterLogo className="w-28" />}
    </div>
  );
}

export default Footer1xbet;
